<template>
	<div class="commande container">
		<div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
			<h2 class="display-4">Commande</h2>
			<p>Nous ne pouvons pas effectuer de livraison.</p>
			<p>Pour finaliser votre commande, choisissez également votre jour et heure de son retrait qui s’effectuera, ainsi que son payement, sur le parking du Garden Centre (les autorités interdisent d’entrer dans notre magasin). </p>
			<p>Vous recevrez un e-mail de confirmation de votre commande avec toutes les informations utiles.</p>
			<p>Nous vous remercions d’avance pour votre commande et vous souhaitons plein de plaisir à jardiner.</p>
			
		</div>
		
		<!-- <pre>{{commande}}</pre> -->
		
		<div class="row">
			<div class="col-md-6 col-lg-5 order-md-2 mb-4">
				<h4 class="d-flex justify-content-between align-items-center mb-3">
					<span>Votre commande</span>
					<span class="badge badge-secondary badge-pill">{{nbPacks}}</span>
				</h4>
				<h5 class="text-muted">Packs</h5>
				<ul class="list-group mb-3">
					<li class="list-group-item d-flex justify-content-between lh-condensed" v-for="(pack,sidx) in selPacks" :key='pack.pack_id'>
						<div>
							<h6 class="my-0">{{`${pack.name}`}}</h6>
							<small class="text-muted">prix unitaire: {{formatPrice(selPacks[sidx].price)}}</small>
						</div>
						<span v-if="pack.status==='DISPO'"><input type = 'number' min="0" max='10' v-model="pack.nb">
						<span  class="text-muted ml-3" >{{formatPrice(pack.price*selPacks[sidx].nb)}}</span></span>
						<span class = 'text-muted' v-if="pack.status !== 'DISPO'">épuisé temporairement</span>
					</li>
				</ul>
				<h5 class="text-muted">Terreaux et jardinières</h5>
				<ul class="list-group mb-3">
					<li class="list-group-item d-flex justify-content-between lh-condensed" v-for="(pack,sidx) in articlePacks" :key='pack.pack_id'>
						<div>
							<h6 class="my-0">{{`${pack.name}`}}</h6>
							<small class="text-muted">prix unitaire: {{formatPrice(articlePacks[sidx].price)}}</small>
						</div>
						<span v-if="pack.status==='DISPO'"><input type = 'number' min="0" :max='maxPack(pack)' v-model="pack.nb">
						<span  class="text-muted ml-3" >{{formatPrice(pack.price*articlePacks[sidx].nb)}}</span></span>
						<span class = 'text-muted' v-if="pack.status !== 'DISPO'">épuisé temporairement</span>
					</li>
				</ul>
				<h5 class="text-muted">Total</h5>
				<ul class="list-group mb-3">
					<li class="list-group-item d-flex justify-content-between">
						<span>Total</span>
						<strong>{{formatPrice(total)}}</strong>
					</li>
				</ul>
			</div>
			<div class="col-md-6 col-lg-7 order-md-1">
				<h4 class="mb-3">Vos coordonnées</h4>
				<form class="needs-validation" novalidate @submit.stop.prevent="sendCommand">
					<div class="row">
						<div class="col-md-6 mb-3">
							<label for="firstName">Prénom</label>
							<input type="text" class="form-control" id="firstName" placeholder="" v-model="commande.prenom" required>
							<div class="invalid-feedback">
								Un prénom valide est requis
							</div>
						</div>
						<div class="col-md-6 mb-3">
							<label for="lastName">Nom de famille</label>
							<input type="text" class="form-control" id="lastName" placeholder="" v-model="commande.nom" required>
							<div class="invalid-feedback">
								Un nom de famille valide est requis
							</div>
						</div>
					</div>

					<div class="mb-3">
						<label for="email">Email </label>
						<input type="email" class="form-control" id="email" v-model="commande.email" placeholder="adresse@exemple.com" required>
						<div class="invalid-feedback">
							Merci d'entrer une adresse email valide
						</div>
					</div>

					<div class="mb-3">
						<label for="tel">Téléphone </label>
						<input type="text" class="form-control" id="tel" v-model="commande.tel" required>
						<div class="invalid-feedback">
							Merci d'entrer un numéro de téléphone
						</div>
					</div>

					<div class="mb-3">
						<label for="address">Adresse</label>
						<input type="text" class="form-control" id="address" placeholder="" v-model="commande.adresse" required>
						<div class="invalid-feedback">
							Merci d'entrer une adresse
						</div>
					</div>

					<div class="row">
						<div class="col-4 mb-3">
							<label for="zip">NPA</label>
							<input type="text" class="form-control" id="zip" name = 'zip' v-model="commande.npa" placeholder="" required>
							<div class="invalid-feedback">
								Merci d'entrer un numéro postal
							</div>
						</div>
						<div class="col-8 mb-3">
							<label for="localite">Localité</label>
							<input type="text" class="form-control" id="localite" v-model="commande.localite" placeholder="" required>
							<div class="invalid-feedback">
								Merci d'entrer une localité
							</div>
						</div>
					</div>

					<hr class="mb-4">

					<h4 class="mb-3">Retrait et payement de votre commande</h4>
					
					<div class="row">
						<div class="col-12 col-lg-4 mb-3">
							<label for="date">Date</label>
							<b-form-datepicker id="date" :date-format-options="{ year: undefined, month: 'long', day: '2-digit', weekday: 'short' }" :min="minDate" :max="maxDate" :date-disabled-fn="dateDisabled" locale="ch-FR" :weekday="1" v-model="commande.date" class="mb-2"></b-form-datepicker>
							<div class="invalid-feedback">
								La date est nécessaire
							</div>
						</div>
						<div class="col-12 col-lg-4 mb-3">
							<label for="heure">Heure</label>
							<select v-model="commande.heure" class = 'form-control' required>
								<option :value="h" v-for="h in hours" :key="h">{{h}}</option>
							</select>
							<div class="invalid-feedback">
								L'heure est nécessaire
							</div>
							<div v-if="heureIndisponible" class = "text-danger">
								<small>Désolé, l'heure n'est plus disponible</small>
							</div>
							<div v-if="jourIndisponible" class = "text-danger">
								<small>Désolé, plus aucune plage horaire n'est disponible pour ce jour</small>
							</div>
						</div>
						<div class="col-12 col-lg-4 mb-3">
							<label for="heure">Payement lors du retrait</label>
							<div class="btn-group d-block">
								<button type = "button" class="btn" :class="(commande.payement=='CASH')?'btn-primary':'btn-outline-primary'" @click="commande.payement='CASH'">Comptant</button>
								<button type = "button" class="btn" :class="(commande.payement=='TWINT')?'btn-primary':'btn-outline-primary'" @click="commande.payement='TWINT'">Twint</button>
							</div>
						</div>
					</div>					
					<hr class="mb-4">
					<button class="btn btn-primary btn-lg" type="submit" :disabled = '!total' v-if="!done">Confirmer la commande</button>
					<div class = 'alert alert-success' v-if="done">Merci pour votre commande. Elle a été envoyée avec succès. Vous allez recevoir un email de confirmation.</div>
				</form>
			</div>
		</div>
		
		
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { HTTP } from '@/router/http'
export default {
	name: 'Commande',
	data () {
		const now = new Date()
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
		const minDate = new Date(today)
		// 15th in two months
		const maxDate = new Date(2020,3,22);
		// maxDate.setMonth(maxDate.getMonth() + 1)
		return {
			commande: {
				commande_id: 'new',
				prenom: '',
				nom: '',
				email: '',
				adresse: '',
				npa: '',
				localite: '',
				tel: '',
				date: new Date('Y-m-d'),
				heure: '',
				payement: 'CASH'
			},
			minDate: minDate,
			maxDate: maxDate,
			hours: [],
			done: false,
			heureIndisponible: false,
			jourIndisponible: false
		}
	},
	methods: {
		maxPack (pack) {
			return (+pack.stock > 10) ? 10 : +pack.stock
		},
		dateDisabled(ymd, date){
			if (ymd) {
				const weekday = date.getDay()
				return weekday === 0 || weekday === 6 
			}
			return false
		},
		sendCommand () {
			let ok = true;
			var forms = document.getElementsByClassName('needs-validation')
			_.forEach(forms, form => {
				if (!form.checkValidity()){
					ok = false;	
					form.classList.add('was-validated')
				} 

			})
			if (ok) {
				let commande = this.commande
				commande.price = this.total
				commande.packs = _.filter(_.map(this.packs, p => {p.nb = +p.nb; return p}),"nb")
				commande.date = moment(commande.date).format('YYYY-MM-DD');
				
				this.checkHeure(this.commande.heure).then(() => {
					HTTP.post('/commande',commande).then(() => {
						this.done = true;
						this.$store.commit("RESET_SELECTIONS")
					})
				}).catch(() => {
					return false
				})				
			}
		},
		formatPrice(price) {
			function formatMoney(number, decPlaces, decSep, thouSep) {
				decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
				decSep = typeof decSep === "undefined" ? "." : decSep;
				thouSep = typeof thouSep === "undefined" ? "," : thouSep;
				var sign = number < 0 ? "-" : "";
				var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
				var j = (j = i.length) > 3 ? j % 3 : 0;

				return sign +
				(j ? i.substr(0, j) + thouSep : "") +
				i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
				(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
			}
			return formatMoney(+price,2, ".", "'");
		},
		getPeriods (date) {
			HTTP.get('/periods/'+moment(date).format('YYYY-MM-DD')).then(res => {
				this.hours = res.data
				this.jourIndisponible = (this.hours.length === 0)
			})
		},
		checkHeure (heure) {
			let _this = this
			const date = moment(this.commande.date).format('YYYY-MM-DD')
			return new Promise ((resolve,reject) => {
				HTTP.get('check_period/'+date+"/"+heure).then(res => {
					if (res.data !== 'OK' && Array.isArray(res.data)) {
						_this.heureIndisponible = true
						_this.commande.heure = '';
						_this.getPeriods(this.commande.date)
						reject(false)
					}
					else this.heureIndisponible = false
					resolve(true)
				})
			})
		}
	},
	computed: {
		...mapGetters({
			packs: 'packs'
		}),
		total () {
			return _.sum(_.map(this.packs, s => +s.nb*+s.price))
		},
		nbPacks () {
			return _.sum(_.map(this.packs, s => +s.nb))
		},
		selPacks () {
			return _.filter(this.packs, p => p.articles.length > 1)
		},
		articlePacks () {
			return _.filter(this.packs, p => p.articles.length === 1)
		}
	},
	watch: {
		'commande.date' (n,o) {
			if (n !== o) {
				this.commande.heure = ''
			}
			this.getPeriods(n)
		},
		'commande.heure' (n,o) {
			if (n !== o && n) {
				this.checkHeure(n).then(() => {
					return true
				}).catch(() => {
					return false
				})
			}
		}
	},
	mounted () {
		let _this = this
		const today = new Date().getDay();
		this.commande.date = (today === 0 || today === 6) ? moment().startOf('isoWeek').add(1, 'week').toDate() : new Date()
		HTTP.get('/periods/'+moment(this.commande.date).format('YYYY-MM-DD')).then(res => {
			_this.hours = res.data
		})
	}
}
</script>

<style scoped>
</style>
